import React from 'react'
import { useLocation } from 'react-router-dom'

import { useMarketplace } from '@src/hooks/useMarketplace'
import { convertToSlug } from '@src/utils/convertToSlug'

import { StyledLink } from './LinkToOutlet.styles'

export const LinkToOutlet: React.FC<{
  outletId: string
  name: string
  className?: string
  dataTestId?: string
  onClick?: () => void
}> = ({ outletId, name, className, children, dataTestId, onClick }) => {
  const { urlPath } = useMarketplace()
  const location = useLocation()

  const handleQueryParamInjection = () => {
    const categoryParams = new URLSearchParams(location.search)
    const categories = categoryParams.get('categories')
    if (categories) {
      sessionStorage.setItem(
        'categoryNavigationParams',
        `?categories=${categories}`
      )
    } else {
      sessionStorage.removeItem('categoryNavigationParams')
    }
  }

  const handleClick = () => {
    handleQueryParamInjection()
    if (onClick) onClick()
  }

  return (
    <StyledLink
      to={`/${urlPath}/${outletId}/${convertToSlug(name)}`}
      onClick={handleClick}
      draggable={false}
      className={className}
      dataTestId={dataTestId}
    >
      {children}
    </StyledLink>
  )
}
